<template>
  <div class="modes-menu">
    <div
      v-for="(objectItem, index) of arrayAvailableMenuItems"
      :key="index"
      class="modes-menu__item"
      :class="{ disabled: !getIsGSUser && !getIsB2CPremium && objectItem.numberActionId === 6 }"
      @click="onClickItem(objectItem)"
    >
      <div class="modes-menu__item__icon">
        <img :src="objectItem.iconUrl" :alt="objectItem.stringTextLineOne" />
      </div>
      <div class="modes-menu__item__text-line-one">
        {{ objectItem.stringTextLineOne }}
      </div>
      <div class="modes-menu__item__text-line-two">
        {{ objectItem.stringTextLineTwo }}
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'MediaPlayerModesMenu',
  data() {
    return {
      arrayMenuItems: [
        {
          iconUrl: 'https://golstatsimages.blob.core.windows.net/todoelfut/icn_media_goals.png',
          stringTextLineOne: 'Goles',
          stringTextLineTwo: 'de la jornada',
          numberActionId: 1,
        },
        {
          iconUrl: 'https://golstatsimages.blob.core.windows.net/todoelfut/icn_media_game.png',
          stringTextLineOne: 'Resumen',
          stringTextLineTwo: 'de un partido',
          numberActionId: 2,
        },
        {
          iconUrl: 'https://golstatsimages.blob.core.windows.net/todoelfut/icn_media_team.png',
          stringTextLineOne: 'Resumen',
          stringTextLineTwo: 'de un equipo',
          numberActionId: 3,
        },
        {
          iconUrl: 'https://golstatsimages.blob.core.windows.net/todoelfut/icn_media_player.png',
          stringTextLineOne: 'Resumen',
          stringTextLineTwo: 'de un jugador',
          numberActionId: 4,
        },
        {
          iconUrl: 'https://golstatsimages.blob.core.windows.net/todoelfut/icn_media_game_full.png',
          stringTextLineOne: 'Partido',
          stringTextLineTwo: 'completo',
          numberActionId: 5,
        },
        {
          iconUrl: 'https://golstatsimages.blob.core.windows.net/todoelfut/icn_media_play_list.png',
          stringTextLineOne: 'Tus playlists',
          stringTextLineTwo: '',
          numberActionId: 6,
        },
        {
          iconUrl: 'https://golstatsimages.blob.core.windows.net/todoelfut/icn_media_surprise_me.png',
          stringTextLineOne: 'Sorpréndeme',
          stringTextLineTwo: '',
          numberActionId: 7,
        },
      ],
    };
  },
  computed: {
    ...mapGetters('loginGeneral', ['getIsGSUser', 'getIsB2CPremium']),
    arrayAvailableMenuItems() {
      if (this.getIsGSUser) {
        return this.arrayMenuItems;
      } else {
        return this.arrayMenuItems.filter(objectMenuItem => objectMenuItem.numberActionId !== 5);
      }
    },
  },
  methods: {
    onClickItem(objectItem) {
      if (!this.getIsGSUser && !this.getIsB2CPremium && objectItem.numberActionId === 6) {
        return;
      }
      this.$emit('click-mode', objectItem.numberActionId);
    },
  },
};
</script>

<style scoped lang="scss">
.modes-menu {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  column-gap: 4px;
  row-gap: 4px;

  &__item {
    padding: 0.7em;
    display: flex;
    flex-direction: column;
    align-items: center;
    border-radius: 12px;
    background-color: #132839;
    cursor: pointer;

    &__icon {
      height: 32px;
      width: 32px;
      margin-bottom: 0.7em;

      & > img {
        height: 32px;
        width: 32px;
      }
    }

    &__text-line-one {
      font-family: Avenir-Demi-Medium, sans-serif;
      font-size: 13px;
      font-weight: 500;
      font-stretch: normal;
      font-style: normal;
      line-height: 0.89;
      letter-spacing: -0.13px;
      text-align: center;
      color: #fff;
    }

    &__text-line-two {
      font-family: Avenir-Demi-Medium, sans-serif;
      font-size: 10px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.16;
      letter-spacing: -0.1px;
      text-align: center;
      color: #fff;
    }
  }

  @media screen and (max-width: 440px) {
    grid-template-columns: repeat(3, 1fr);
  }

  @media screen and (max-width: 344px) {
    grid-template-columns: repeat(2, 1fr);
  }
}

.disabled {
  cursor: default;
  opacity: 0.8;
}
</style>
